import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LookupCmsPackUpload from '../../components/lookup/LookupCmsPackUpload';
import '../../components/lookup/lookup.css';

/** Account-wide CMS MS-DRG pack ingestion (CaseId IS NULL). */
export default function LookupCmsPackUploadPage() {
  const navigate = useNavigate();
  return (
    <div className="cms-pack">
      <div className="cms-pack__breadcrumb">
        <Link to="/admin/lookup">Lookup</Link> &nbsp;/&nbsp; Ingest CMS MS-DRG Pack
      </div>
      <h1>Ingest CMS MS-DRG Definitions Manual</h1>
      <p className="cms-pack__sub">
        Drop the fixed-width text files from the CMS MS-DRG ICD-10 Definitions Manual
        (appendix_A/B/C/D_E/F_I, mdcs_NN_MM, Definitions of Medicare Code Edits). The backend dispatches each
        file to a specialized parser and inserts normalized records into your account-wide Lookup table.
        Duplicates are skipped per (code, category).
      </p>

      <LookupCmsPackUpload onIngested={() => { /* results render inline */ }} />

      <div className="cms-pack-actions" style={{ marginTop: 16 }}>
        <button type="button" className="cms-pack-btn cms-pack-btn--ghost" onClick={() => navigate('/admin/lookup')}>
          Back to Lookup
        </button>
      </div>
    </div>
  );
}
